import styled, { css } from "styled-components";
import FlexBox from "../../../../FlexBox/FlexBox";

export const _InnovationProductMargauxMotinRoot = styled(FlexBox)<{}>(
  () => {
    return {
      ".innovation-product-action-button": {
        marginTop: 8,
      },
    };
  },
  css`
    position: relative;
    margin-top: auto;
    padding-bottom: 90px;
    overflow: visible;

    .innovation-product-margaux-motin-content {
      max-width: 247px;
      position: relative;
      height: 100%;
    }
  `
);
